import { Anchor, Car, Home, Waves } from 'lucide-react';

import { Container } from '../ui/Container';

import type { LucideIcon } from 'lucide-react';

interface Amenity {
  icon: LucideIcon;
  title: string;
  body: string;
}

const amenities: Amenity[] = [
  {
    icon: Waves,
    title: 'Pool',
    body: 'Refurbished 2023-2024. Fenced and open to all owners.',
  },
  {
    icon: Anchor,
    title: 'Dock',
    body: 'Replaced 2024. River access on the Banana River, steps from the building.',
  },
  {
    icon: Car,
    title: 'Covered Garage',
    body: 'Fifty-two covered parking spaces. Each unit deeded a limited common element.',
  },
  {
    icon: Home,
    title: 'Clubhouse',
    body: 'Community room for board meetings, gatherings, and owner events.',
  },
];

export function AmenitiesStrip(): JSX.Element {
  return (
    <section className="section bg-brand-surface">
      <Container>
        <div className="mb-12 max-w-2xl">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-brand-yellow-deep">
            Amenities
          </p>
          <h2 className="text-3xl font-bold tracking-heading-tight text-brand-charcoal md:text-4xl">
            Built for everyday use
          </h2>
        </div>
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {amenities.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              className="flex flex-col rounded-lg bg-brand-white p-7 shadow-card transition-shadow hover:shadow-card-hover"
            >
              <span className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-full bg-brand-yellow text-brand-charcoal">
                <Icon size={22} strokeWidth={2} />
              </span>
              <h3 className="text-lg font-bold text-brand-charcoal">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-brand-body-dark">{body}</p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
